<script lang="ts">
  import type { DataHandler } from '@vincjo/datatables/remote';
  import IconButton from '$lib/components/common/iconButton/IconButton.svelte';

  export let handler: DataHandler;

  const pageNumber = handler.getPageNumber();
  const pageCount = handler.getPageCount();
  const rowCount = handler.getRowCount();

  const setPage = (value: 'previous' | 'next' | number) => {
    handler.setPage(value);
    handler.invalidate();
  };
</script>

<!-- Desktop buttons -->
<div class="inline-flex h-5 min-w-[116px] items-center justify-end rounded border border-surface-600 bg-white p-4">
  <div class="text-md flex items-center justify-start text-[--text2]">
    <IconButton class="mr-1 !h-[20px] !w-[20px]" icon="caret-left" disabled={$pageNumber === 1} onClick={() => setPage(1)} />
    <IconButton class="!h-[20px] !w-[20px]" icon="arrow-left" disabled={$pageNumber === 1} onClick={() => setPage('previous')} />
    <div class="mx-4 font-medium text-[--text2]">
      {$rowCount.start}-{$rowCount.end} of {$rowCount.total}
    </div>
    <IconButton class="!h-[20px] !w-[20px]" icon="arrow-right" disabled={$pageNumber === $pageCount} onClick={() => setPage('next')} />
    <IconButton class="ml-1 !h-[20px] !w-[20px]" icon="caret-right" disabled={$pageNumber === $pageCount} onClick={() => setPage($pageCount)} />
  </div>
</div>
